/**
 * Sawyer E4 (#754) — the Team messages unread count in the shell.
 *
 *   placement="nav"   on the Team messages nav item: end of the row on the
 *                     ≥1080px sidebar, over the icon on the 720–1079px rail
 *   placement="menu"  on the <720px hamburger, where the nav lives in a
 *                     drawer (review C2 fallback: a separate top-bar button
 *                     squeezed the page title to 3px once lane 17's Help
 *                     button sat beside it, so phones get the count on the
 *                     menu button and reach Team messages in two taps)
 *
 * Both read the one shared poller (one request per tick for the whole tab,
 * P1). Renders nothing at 0, before the first answer, or when the staffer
 * cannot reach Team messages / the server does not have it yet (AC17).
 */
import './team-messages-shell.css';
import { useStaffMessagesUnread } from './useStaffMessagesUnread.js';
import { useTeamMessagesAccess } from './useTeamMessagesAccess.js';

export function formatCount(n: number): string {
  return n > 99 ? '99+' : String(n);
}

export function UnreadBadge({
  apiUrl,
  placement = 'nav',
}: {
  apiUrl: string;
  placement?: 'nav' | 'menu';
}): JSX.Element | null {
  const { visible } = useTeamMessagesAccess();
  const counts = useStaffMessagesUnread(apiUrl, visible);
  if (!counts || counts.total === 0) return null;
  const label = `${counts.total} unread team messages`;
  return placement === 'nav' ? (
    <span className="ferro-tm-badge ferro-tm-badge--nav" data-testid="team-messages-nav-badge" aria-label={label}>
      {formatCount(counts.total)}
    </span>
  ) : (
    // Inside the menu button (whose own aria-label names it), so the count
    // is read from the drawer item's badge; this one is visual only.
    <span className="ferro-tm-badge ferro-tm-badge--menu" data-testid="team-messages-menu-badge" aria-hidden="true">
      {formatCount(counts.total)}
    </span>
  );
}
